import {
  YotpoTooltip
} from "./chunk.KPYPODQD.js";
import {
  __decorateClass
} from "./chunk.U4VUMZVF.js";

// src/utilities/overflowable-compoenent.ts
import { LitElement } from "lit";
import { state } from "lit/decorators.js";
var OverflowableComponent = class extends LitElement {
  constructor() {
    super(...arguments);
    this.isOverflow = false;
  }
  async firstUpdated() {
    await this.updateComplete;
    this.checkOverflow();
  }
  checkOverflow() {
    this.isOverflow = this.isComponentOverflowParent(this);
    if (this.isOverflow)
      this.style.width = "100%";
  }
  isComponentOverflowParent(component) {
    if (component.parentElement)
      return component.scrollWidth > component.parentElement.clientWidth && !(component.parentElement instanceof YotpoTooltip);
    return false;
  }
};
__decorateClass([
  state()
], OverflowableComponent.prototype, "isOverflow", 2);

export {
  OverflowableComponent
};
